var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.modelCells, function (module) {
      return _c("questionnaire-view-module", {
        key: module.id,
        attrs: {
          config: _vm.questionnaire.config,
          globals: _vm.questionnaire.globals,
          model: module,
          response: _vm.questionnaire.response,
          template: _vm.getTemplate(module.id),
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }